import * as colors from '@giphy/colors'
import styled from 'styled-components'
import { allLetters } from 'types'

const filterLetters = ['#', ...allLetters] as const

const Container = styled.div`
    display: flex;
    overflow-x: auto;
    width: 100%;
    -webkit-overflow-scrolling: touch;
`

const Filter = styled.div<{ active: boolean }>`
    color: ${(props) => (props.active ? colors.giphyWhite : colors.giphyLightCharcoal)};
    display: block;
    font-size: 16px;
    font-weight: bold;
    padding: 5px 10px;
    text-align: left;
    text-transform: uppercase;
    width: 100%;
    cursor: pointer;

    &:hover {
        color: ${colors.giphyWhite};
    }
`

type Props = {
    filter?: string
    onChange: (letter?: string) => void
}

const ArtistFilters = ({ filter = '', onChange }: Props) => (
    <Container>
        <Filter active={!filter} onClick={() => onChange('')}>
            All
        </Filter>
        {filterLetters.map((letter) => (
            <Filter key={letter} active={letter === filter} onClick={() => onChange(letter)}>
                {letter}
            </Filter>
        ))}
    </Container>
)

export default ArtistFilters
